(() => {
  const buildBlock = () => {
    const block = document.createElement('section');
    block.className = 'hb-cart-reassurance';
    block.setAttribute('aria-label', 'Order information');
    block.innerHTML = `
      <h3 class="hb-cart-reassurance__title">A few helpful details before checkout</h3>
      <ul class="hb-cart-reassurance__list">
        <li class="hb-cart-reassurance__item"><span class="hb-cart-reassurance__icon" aria-hidden="true">✓</span><span><strong>Simple U.S. shipping:</strong> Ground shipping is $4.95 under $59 and free at $59+, after discounts and before taxes.</span></li>
        <li class="hb-cart-reassurance__item"><span class="hb-cart-reassurance__icon" aria-hidden="true">%</span><span><strong>Group savings apply automatically:</strong> 5+ eligible kits save 5%, 10+ save 10%, and 20+ save 15%.</span></li>
        <li class="hb-cart-reassurance__item"><span class="hb-cart-reassurance__icon" aria-hidden="true">✦</span><span><strong>Physical kits are ready for a creative night:</strong> Canvas-only options include a pre-drawn 9×12 canvas board. Complete kits add paints, brushes, a disposable apron, reusable wooden tabletop easel, and finished painting reference. Video and live instruction are not included.</span></li>
      </ul>
      <p class="hb-cart-reassurance__fineprint">Eligible kit discounts are based on physical Paint Party Kits and are reflected automatically when the qualifying quantity is in your cart.</p>`;
    return block;
  };

  const inject = (summary) => {
    if (!summary || summary.querySelector('.hb-cart-reassurance')) return;
    const checkout = summary.querySelector('.cart__ctas');
    const totals = summary.querySelector('.cart-totals');
    if (checkout) checkout.insertAdjacentElement('beforebegin', buildBlock());
    else if (totals) totals.insertAdjacentElement('afterend', buildBlock());
  };

  const enhance = () => document.querySelectorAll('.cart-drawer__summary').forEach(inject);
  const start = () => {
    enhance();
    const observer = new MutationObserver(enhance);
    observer.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
